import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipmentsPanelHeader: {
    defaultMessage: 'SHIPMENTS',
    description: 'Header for a panel that displays a list of shipments',
    id: 'pi0g0W',
  },
});
